import SharingDialog, { ShareProps } from './SharingDialog';
import { closeSharingDialog } from '../actions/internalActions';
import { SharingDialogStore } from '../store/schema/SharingDialogStore';
import { SharingDialogResponse } from '../types/SharingDialogResponse';
import { observer } from 'mobx-react';
import { Modal } from 'office-ui-fabric-react/lib/Modal';
import * as React from 'react';

const styles = require('./sharingDialog.scss');

export interface ShareModalProps {
    shareProps: ShareProps;
    sharingDialogStore: SharingDialogStore;
    onDismiss: (result?: SharingDialogResponse) => void;
}

@observer
export default class ShareModal extends React.Component<ShareModalProps, {}> {
    render() {
        return (
            <Modal
                className={styles.sharingDialog}
                isOpen={this.props.sharingDialogStore.viewState.isOpen}
                onDismiss={closeSharingDialog}>
                <SharingDialog onDismiss={this.props.onDismiss} {...this.props.shareProps} />
            </Modal>
        );
    }
}
